import { UtilityHelper } from '@/helpers/UtilityHelper';

const supportedLocales = {
    en: 'English',
    pl: 'Polish',
    lt: 'Lithuanian',
    lv: 'Latvian',
    es: 'Spanish',
    ru: 'Russian',
    ua: 'Ukraine',
    cz: 'Czech Republic',
    fr: 'French',
    it: 'Italian',
    de: 'German',
    pt: 'Portuguese',
    nl: 'Dutch',
    ro: 'Romonia',
};

export const LanguageCodeByBranchCode: Record<string, string> = {
    en: 'en',
    pl: 'pl',
    lt: 'lt',
    lv: 'lv',
    es: 'es',
    ru: 'ru',
    ua: 'uk',
    cz: 'cs',
    fr: 'fr',
    it: 'it',
    de: 'de',
    pt: 'pt',
    nl: 'nl',
    ro: 'ro',
};

const langExpirationTime = 5;

export class I18nHelpers {
    constructor() {
        if (this.constructor === I18nHelpers) {
            throw new Error("Can't create the instance of i18n.");
        }
    }

    public static supportedLocalesIncludes(locale: string) {
        return Object.keys(supportedLocales).includes(locale);
    }

    public static isExpired(locale: string) {
        return (
            Date.now() -
                parseInt(localStorage.getItem(`timestamp_${locale}`) || '0') >
            langExpirationTime * 1000 * 60
        );
    }

    public static isSet(locale: string) {
        return localStorage.getItem(`lang_${locale}`);
    }

    public static setLocaleTranslation(locale: string, translation: any) {
        localStorage.setItem(`lang_${locale}`, JSON.stringify(translation));
    }

    public static setLocaleTimestamp(locale: string) {
        localStorage.setItem(`timestamp_${locale}`, Date.now().toString());
    }

    public static loadLocaleTranslation(locale: string) {
        return JSON.parse(localStorage.getItem(`lang_${locale}`) || '{}');
    }

    public static getAppLocale() {
        const urlLocale = UtilityHelper.getLocale();
        if (I18nHelpers.supportedLocalesIncludes(urlLocale)) {
            return urlLocale;
        } else {
            return process.env.VUE_APP_I18N_LOCALE || 'en';
        }
    }
}
